import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { usePopularPosts, useRecentPosts } from "../hooks"

const Sidebar = ({ relatedPosts }) => {
  const { nodes: popularPosts } = usePopularPosts()
  const { nodes: recentPosts } = useRecentPosts()

  // 共通のサイドバーアイテムコンポーネント
  const SidebarItem = ({ post }) => (
    <div
      key={`side-${post.fields.slug}`}
      className="w-full mt-6 duration-200 hover:text-blue-500"
    >
      <Link className="flex items-start gap-3" to={post.fields.slug}>
        <div
          className="relative overflow-hidden rounded-lg bg-gray-100 flex-shrink-0"
          style={{ width: "120px", height: "80px" }}
        >
          <GatsbyImage
            image={post.frontmatter.thumbnail?.childImageSharp.gatsbyImageData}
            alt={post.frontmatter.title}
            className="w-full h-full"
            imgStyle={{ objectFit: "cover" }}
          />
        </div>
        <p className="font-bold text-sm leading-tight line-clamp-3 flex-1">
          {post.frontmatter.title}
        </p>
      </Link>
    </div>
  )

  return (
    <>
      <div className="side-card">
        <div className="side-title">関連記事</div>
        <div className="side-content">
          {relatedPosts.map(post => (
            <SidebarItem key={`related-${post.fields.slug}`} post={post} />
          ))}
        </div>
      </div>
      <div className="side-fixed">
        <div className="side-card">
          <div className="side-title">人気記事</div>
          <div className="side-content">
            {popularPosts.map(post => (
              <SidebarItem key={`popular-${post.fields.slug}`} post={post} />
            ))}
          </div>
        </div>
        <div className="side-card mt-6">
          <div className="side-title">新着記事</div>
          <div className="side-content">
            {recentPosts.map(post => (
              <SidebarItem key={`recent-${post.fields.slug}`} post={post} />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Sidebar
